store.termsDialogParams = {
	modal: true,
	height: 300,
	width: 500
};
store.launchTerms = function() {
	var $link = $(this);
	var $dialog = $('#storeDialog');
	if ($dialog.length === 0) {
		$dialog = $('<div id="storeDialog" style="display:none"></div>').appendTo('body');
	}
	store.local.prepareTermsDialogParams($dialog, $link);
	$dialog.load(
		store.url(store.action.terms, ''),
		{},
		function () {
			$dialog.dialog(store.termsDialogParams);
		}
	);
	return false;
};

store.initPaymentSelection = function() {
	$('ul.paymentTypeSelection li').click(function(){
		$('input', this).attr('checked','checked');
	});
};

store.changeCountryClick = function(e) {
	var dialog = $('#storeDialog');
	if (dialog.length === 0) {
		dialog = $('<div id="storeDialog" style="display:none"></div>').appendTo('body');
	}
	var title = (this.title) ? this.title : '';
	dialog.load(
		store.url(store.action.countrySelection, ''),
		{},
		function () {
			dialog.dialog({
				modal: true,
				height: 200,
				width: 400,
				title: title
			});
		}
	);
	e.preventDefault();
	return false;
};

store.sorter = {};
store.sorter.init = function() {
	var $f = $('#storeSorter').find('form');
	store.form.autoChange($f, 'storeSelector');
	store.form.ajax($f, {
		'.categoryProducts': '#store .category .categoryProducts'
	}, function() {
		store.local.onCategoryProductsUpdate();
	});
};
store.t = {};
store.t.translations = {};
store.t.addTranslations = function(a) {
	jQuery.extend(store.t.translations, a);
};
store.t.__ = function(k) {
	var r = k;
	if (store.t.translations[k]) {
		r = store.t.translations[k];
	}
	return r;
};
// http://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-money-in-javascript/149099#149099
store.numberFormat = function(n, decPlaces, thouSeparator, decSeparator) {
	decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces;
	decSeparator = (typeof decSeparator == 'undefined') ? "." : decSeparator;
	thouSeparator = (typeof thouSeparator == 'undefined') ? "," : thouSeparator;
	var sign = n < 0 ? "-" : "";
	var i = parseInt(n = Math.abs(+n || 0).toFixed(decPlaces)) + "";
	var j;
	j = (j = i.length) > 3 ? j % 3 : 0;
	return sign +
		(j ? i.substr(0, j) + thouSeparator : "") +
		i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thouSeparator) +
		(decPlaces ? decSeparator + Math.abs(n - i).toFixed(decPlaces).slice(2) : "");
};

store.responsiveImg = function($parent, selector) {
	if ($.isFunction($.fn.responsiveImg)) {
		if (!selector) selector = 'img.responsive';
		if (!$parent) $parent = $('#store');
		if ($parent instanceof jQuery) {
			$parent.find(selector).responsiveImg();
		}
	}
};
store.isFormRequirementsValid = function($form) {
	var $requiredElements = $form.find(':input[aria-required=true]').filter(':visible');
	var ret = true;
	$requiredElements.each(function(){
		var val = $(this).val();
		if (!val || val.length < 0) {
			ret = false;
			return false; // break
		}
	});
	return ret;
};
store.makeRadioGroupDeselectable = function (parentElement) {
	if (!NodeList.prototype.forEach) {
		return;
	}

	var current;
	parentElement.querySelectorAll('input[type=radio]').forEach(function (elm) {
		elm.addEventListener('click', function (e) {
			if (this.id === current) {
				this.checked = false;
				current = null;
				// only time the click is not triggered in jQuery
				$(this).trigger('change');
			}
			else {
				current = this.id;
			}
		});
		if (elm.checked) {
			current = elm.id;
		}
	});
};
